<div id="rti-details" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">RTI Details</h2>
    <p class="inner-lead mt-3">
      In accordance with the Right to Information Act 2005, Shah Satnam Ji Girls' College, Sirsa maintains transparency
      and provides information to the public. Below are the mandatory disclosures and details of the Public Information
      Officer.
    </p>

    <hr class="divider">

    <div class="pdf-block mt-4">
      <pdf-viewer src="/assets/pdf/info/Information-of-RTI.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:800px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-4">
      <a href="/assets/pdf/info/Information-of-RTI.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download me-2"></i> Download RTI Details (PDF)
      </a>
    </div>
  </div>
</div>